import httpClient from '@/http-client'

export const paymentDetail = data => {
  return httpClient
    .post('/api/report/payment-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const paymentDetailExcel = data => {
  return httpClient
    .post('/api/report/payment-detail-excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const summary = data => {
  return httpClient
    .post('/api/report/summary-cash-collections', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const summaryExcel = data => {
  return httpClient
    .post('/api/report/summary-cash-collections-excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const bycashier = data => {
  return httpClient
    .post('/api/report/cash-collection-by-cashiers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getCashier = data => {
  return httpClient
    .get('/api/report/query-cashiers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const byservice = data => {
  return httpClient
    .post('/api/report/payment-by-services', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlypayment = data => {
  return httpClient
    .post('/api/report/monthly-payments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getStudentUnpaid = (Options = {}) => {
  return httpClient
    .get('/api/report/student-unpaids', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const studentUnpaid = data => {
  return httpClient
    .post('/api/report/student-unpaids', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const voidInvoice = data => {
  return httpClient
    .post('/api/report/void-invoices', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const annualPayment = data => {
  return httpClient
    .post('/api/report/annual-payments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const overduePayment = data => {
  return httpClient
    .post('/api/report/overdue-payments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const studentPayment = data => {
  return httpClient
    .post('/api/report/student-payments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const studentPaymentExcel = data => {
  return httpClient
    .post('/api/report/student-payment-excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const getClassSchedule = teacher_id => {
  return httpClient
    .get(`/api/report/query-class-operations/${teacher_id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const discountPayment = data => {
  return httpClient
    .post('/api/report/discount-payments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const yearlyPaymentList = data => {
  return httpClient
    .post('/api/report/yearly-payment-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const saleDayBook = data => {
  return httpClient
    .post('/api/report/sale-day-books', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const saleDayBookExcel = data => {
  return httpClient
    .post('/api/report/sale-day-book-excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const paymentTracking = data => {
  return httpClient
    .post('/api/report/payment-trackings', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = Options => {
  return httpClient
    .get('/api/report/payment-trackings/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data));
}

export const paymentTrackingExcel = data => {
  return httpClient
    .post('/api/report/payment-tracking-excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  paymentDetail,
  paymentDetailExcel,
  summary,
  summaryExcel,
  bycashier,
  getCashier,
  byservice,
  monthlypayment,
  studentUnpaid,
  voidInvoice,
  annualPayment,
  overduePayment,
  studentPayment,
  studentPaymentExcel,
  getClassSchedule,
  discountPayment,
  getStudentUnpaid,
  yearlyPaymentList,
  saleDayBook,
  saleDayBookExcel,
  paymentTracking,
  paymentTrackingExcel,
  formViewModel
}
